<template>
	<div style="background: #F0F0F0">
		<div id="content" style="overflow: hidden;">
			<div ref="mbBox" id="mbBox" class="mb-set-box clearfix" style="overflow: auto;">
				<div class="mb-phone fl">
					<div class="phone-top">
						<img style="z-index:999 !important;" src="../assets/imgs/phone-top.png">
					</div>
					<div ref="Rank" @click="showModel('Rank')">
						<div class="cover-img border-bottom white-bj cor" :class="isFMR?'br_green':''" style="position: relative;">
							<img class="kz" style="width: 100%;" :src="form.posterSrc" alt="">
							<h3 style="font-weight: normal;">{{form.comName}}</h3>
						</div>
					</div>
					<div ref="Company" class="big-box1 cor" :class="item.isCompany?'br_green':''" @click="showModel('Company',index)"
					 style="text-align: left;" v-for="(item,index) in comList">
						<div class="company-js border-bottom white-bj padding16">
							<h3><i></i><a id="context2-1">{{item.title}}</a></h3>
							<div class="com-img mat16" v-show="item.pic_name">
								<img :src="item.pic_name" id="image2">
							</div>
							<div class="com-text mat06">
								<p id="context2-2">{{item.content}}
								</p>
							</div>
						</div>
						<!--遮罩-->
						<div class="blue-box1" id="blue-box1">
							<h3>公司介绍</h3>
							<div class="delet-odd" v-if="index>0" @click.stop="delModule(index)">
								<a href="javascript:void(0)"></a>
							</div>
						</div>
					</div>
					<div class="add-div white-bj border-bottom" @click="addModule">
						<a href="javascript:void(0)"><img src="../assets/imgs/add-4.png"></a>
					</div>
					<!-- 联系方式 -->
					<div ref="LX" class="big-box2 cor" @click="showModel('LX')" :class="isLXR?'br_green':''" style="text-align: left;">
						<div class="company-js contect border-bottom white-bj padding16">
							<h3><i></i><a>联系方式</a></h3>
							<ul class="contect-list">
								<li>
									<label>联系电话：</label>
									<a id="context3-1">{{form.mobilePhone}}</a>
								</li>
								<li>
									<label>公司官网：</label>
									<a id="context3-2">{{form.comWebsite}}</a>
								</li>
								<li>
									<label>公司地址：</label>
									<a id="context3-3">{{form.comAddress}}</a>
								</li>
								<li>
									<label>微博名称：</label>
									<a id="context3-4">{{form.wbName}}</a>
								</li>
							</ul>
						</div>
						<!--遮罩-->
						<div class="blue-box2 hide" style="display: none;">
							<h3>联系方式</h3>
						</div>
					</div>
					<!-- 联系方式 -->
					<div ref="KF" class="big-box2 cor" @click="showModel('KF')" :class="isKF?'br_green':''" style="text-align: left;">
						<div class="company-js contect border-bottom white-bj padding16">
							<h3><i></i><a>客服信息</a></h3>
							<ul class="contect-list">
								<li>
									<label>客服电话：</label>
									<a id="context3-1">{{form.kfPhone}}</a>
								</li>
								<li>
									<label>客服QQ：</label>
									<a id="context3-2">{{form.kfQQ}}</a>
								</li>
							</ul>
						</div>
						<!--遮罩-->
						<div class="blue-box2 hide" style="display: none;">
							<h3>客服信息</h3>
						</div>
					</div>
					<div class="phone-top">
						<img src="../assets/imgs/phone-bottom.png">
					</div>
				</div>
				<!--弹框-->
				<div id="param" class="mb-popou fl" :model="form">

					<!--弹框1封面-->
					<div class="popou-commen popou02 padding20 clearfix a-fadeinR" v-if="isFMR" style="margin-top: 42px;">
						<i class="trangle1"></i>
						<i class="cloose2" @click="delModel('FM');"></i>
						<ul class="com-list com-list2">
							<li class="pic-box clearfix">
								<label class="fl">封面图：</label>
								<!-- <el-upload class="upload-avatar fl" :action="$api+'/upload/uploadImageFile'" :on-remove="handlePosterRemove"
								 :on-success="handlePosterSuccess" list-type="picture" :on-change="getPosterChange">
									<el-button size="middle" type="primary">上传封面图</el-button>
								</el-upload> -->
								<el-upload class="upload-avatar fl" :action="$api+'/upload/uploadImageFile'" :show-file-list="false" :on-success="handlePosterSuccess" :on-change="getPosterChange">
									<el-button size="middle" type="primary">上传封面图</el-button>
								</el-upload>
								<div class="previewBox">
									<div v-if="form.posterSrc&&form.posterSrc.indexOf('pic_8')<0" style="width: 90px;height: 60px;border: 1px solid #E1E1E1;overflow: hidden;text-align: center;display: table;vertical-align: middle;">
										<div style="width: 90px;height: 60px;display: table-cell;text-align: center;vertical-align: middle;">
											<img :src="form.posterSrc" alt="" style="max-width: 90px;max-height: 67px;">
										</div>
										<a href="javascript:void(0)" class="cloose111" @click="handlePosterRemove" id="deleImage5"></a>
									</div>
								</div>
							</li>
							<p class="tishi-gray re-position">建议上传360*140的图片，大小不超过5M</p>
							<li>
								<label>企业名称：</label>
								<input id="ne" type="text" v-model="form.comName">
							</li>
						</ul>
					</div>
					<!--弹框2-->
					<div :key="index"  v-for="(item,index) in comList">
						<div ref="companyBlock" class="popou-commen popou02 padding20 clearfix a-fadeinR" v-show="item.isCompany">
							<i class="trangle1"></i>
							<i class="cloose2" @click="delModel('Company',index);"></i>
							<ul class="contect-list com-list2 ">
								<li>
									<label>标题：</label>
									<input v-model="item.title" :id="'title'+index" maxlength="20" type="text">
								</li>
								<li class="pic-box clearfix" style="width: 100%;">
									<label>图片：</label>
									<el-upload class="uploadPic fl" :id="'upload'+index" :action="$api+'/upload/uploadImageFile'" :show-file-list="false" :on-success="(response, file, fileList) => handlePicSuccess(index, response, file, fileList)">
										<el-button size="middle" type="primary">上传图片</el-button>
									</el-upload>
									<div class="previewBox">
										<div v-if="item.pic_name" style="width: 90px;height: 60px;border: 1px solid #E1E1E1;overflow: hidden;text-align: center;display: table;vertical-align: middle;">
											<div style="width: 90px;height: 60px;display: table-cell;text-align: center;vertical-align: middle;">
												<img :src="item.pic_name" alt="" style="max-width: 90px;max-height: 67px;">
											</div>
											<a href="javascript:void(0)" class="cloose111" @click="handlePicRemove(index)" id="deleImage5"></a>
										</div>
									</div>
								</li>
								<p class="tishi-gray re-position">建议上传360*140的图片，大小不超过5M</p>
								<li>
									<label>内容：</label>
									<textarea :id="'content'+index" style="font-size: 14px;color: #333;font-family: '微软雅黑';border: 1px solid #E1E1E1;line-height: 1.5;padding: 0 10px;"
									 cols="30" rows="10" v-model="item.content"></textarea>
								</li>
								<li>
									<label>链接：</label>
									<input v-model="item.href" :id="'href'+index" type="text" @change="onLinkChange($event,index)">
								</li>
								<p style="font-size: 12px;color: #999999 ;text-align: center;margin-top: 6px;">点击标题跳转到此链接</p>
							</ul>
						</div>
					</div>
					<!--弹框3-->
					<div ref="LXRbox" class="popou-commen popou02 padding20 clearfix a-fadeinR" v-if="isLXR">
						<i class="trangle1"></i>
						<i class="cloose2" @click="delModel('LX');"></i>
						<ul class="contect-list com-list2 ">
							<li>
								<label>联系电话：</label>
								<input id="c" maxlength="20" type="text" v-model="form.mobilePhone">
							</li>
							<li>
								<label>公司官网：</label>
								<input id="c" maxlength="20" type="text" v-model="form.comWebsite" @change="onWebsiteChange">
							</li>
							<li>
								<label>公司地址：</label>
								<input id="c" maxlength="50" type="text" v-model="form.comAddress">
							</li>
							<li>
								<label>微博名称：</label>
								<input id="c" maxlength="20" type="text" v-model="form.wbName">
							</li>
						</ul>
					</div>


					<!--弹框4-->
					<div ref="KFbox" class="popou-commen popou02 padding20 clearfix a-fadeinR" v-if="isKF">
						<i class="trangle1"></i>
						<i class="cloose2" @click="delModel('KF');"></i>
						<ul class="contect-list com-list2 ">
							<li>
								<label>客服电话：</label>
								<input id="c" maxlength="20" type="text" v-model="form.kfPhone">
							</li>
							<li>
								<label>客服QQ：</label>
								<input id="c" maxlength="20" type="text" v-model="form.kfQQ">
							</li>
							<p class="tishi-gray re-position" style="text-align: left;">请尽量填写真实的QQ号，方便您的客户及时联系您</p>
						</ul>
					</div>
				</div>
				<!-- 预览 -->
				<el-dialog :visible.sync="yardImgshow" class="previewBox2" width="360px">
					<img src="../assets/imgs/phone-top.png" alt="">
					<div class="phoneBox">
						<div class="cover-img1 border-bottom white-bj cor">
							<img :src="form.posterSrc" style="width: 100%;">
							<h3>{{form.comName}}</h3>
						</div>
						<div class="big-box11 cor" style="text-align: left;" v-for="(item,index) in comList">
							<div class="company-js border-bottom white-bj padding16">
								<h3><i></i><a class="previewA" @click="gotoUrl(item.href);">{{item.title}}</a></h3>
								<div class="com-img mat16">
									<img :src="item.pic_name">
								</div>
								<div class="com-text mat061">
									<font>{{item.content}}</font>
								</div>
							</div>
						</div>
						<div class="big-box21 cor" style="text-align: left;" v-show="form.mobilePhone || form.comWebsite || form.comAddress || form.wbName">
							<div class="company-js contect border-bottom white-bj padding16">
								<h3><i></i><a class="previewA">联系方式</a></h3>
								<ul class="contect-list">
									<li v-show="form.mobilePhone">
										<label>联系电话：</label>
										<a class="previewA">{{form.mobilePhone}}</a>
									</li>
									<li v-show="form.comWebsite">
										<label>公司官网：</label>
										<a class="previewA">{{form.comWebsite}}</a>
									</li>
									<li v-show="form.comAddress">
										<label>公司地址：</label>
										<a class="previewA">{{form.comAddress}}</a>
									</li>
									<li v-show="form.wbName">
										<label>微博名称：</label>
										<a class="previewA">{{form.wbName}}</a>
									</li>
								</ul>
							</div>

						</div>
						<div class="big-box31 cor" style="text-align: left;" v-show="form.kfPhone || form.kfQQ">
							<div class="company-js service white-bj border-bottom padding16">
								<h3><i></i>
									<a class="previewA">客服信息</a>
								</h3>
								<ul class="contect-list">
									<li>
										<label>客服电话：</label>
										<a class="previewA">{{form.kfPhone}}</a>
									</li>
									<li>
										<label>客服QQ：</label>
										<a class="previewA">{{form.kfQQ}}</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<img src="../assets/imgs/phone-bottom.png" alt="">
				</el-dialog>
				<!--download-->
				<div class="download-box fr">
					<div class="popou-ma1">
						<p>手机扫一扫，预览最新效果</p>
						<div class="ma-box re-margin">
							<img id="idcodeImg" :src="this.codeSrc" v-show="this.codeShow">
						</div>
						<div class="download-btns clearfix" style="margin-bottom: 10px;">
							<!-- <input type="button" value="预览" onclick="savePerson('preview');">
							<input type="button" value="保存" onclick="savePerson('hold');"> -->
							<el-button type="primary" size="small" @click="saveCompany(0)">预览</el-button>
							<el-button type="primary" size="small" @click="saveCompany(1)">保存</el-button>
							<!-- <input id="button_id" type="button" value="码图设置" onclick="maTSZ();" style="display: none;"> -->
						</div>

						<div class="line"></div>
						<h3>选择码制</h3>
						<div class="popou-choose">
							<el-checkbox-group v-model="checkList" @change="onMzchange">
							   <el-checkbox label="汉信码"></el-checkbox>
							   <el-checkbox label="龙贝码"></el-checkbox>
							   <el-checkbox label="GM码"></el-checkbox>
							   <el-checkbox label="QR码"></el-checkbox>
							  </el-checkbox-group>
						</div>
						<h3>选择码标</h3>
						<div class="popou-choose">
							<el-select v-model="mbVal" placeholder="请选择" @change="onMbchange">
								<el-option v-for="item in mbList" :key="item.identification_ID" :label="item.identification" :value="item.identification_ID">
								</el-option>
							</el-select>
						</div>
						<div class="btn-long" style="margin: 20px 0;">
							<!-- <input type="button" onclick="zipDownloads();" value="打包下载码图"> -->
							<el-button type="warning" @click="downloadCode">打包下载码图</el-button>
						</div>
					</div>
				</div>
				<input type="hidden" id="mycity" value="石家庄市">
				<input type="hidden" id="hidQRSrc" name="hidQRSrc" value="20220318135405125.jpg">
				<input type="hidden" id="hidLBSrc" name="hidLBSrc" value="20220318135405474.jpg">
				<input type="hidden" id="hidHXSrc" name="hidHXSrc" value="20220318135405224.jpg">
				<input type="hidden" id="hidGMSrc" name="hidGMSrc" value="20220318135405225.jpg">
				<input type="hidden" id="categoryregId" name="categoryregId">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'personalEdit',
		data() {
			return {
				comList: [{ // 公司列表
					title: 'xx集团有限责任公司', //标题
					pic_name: require('../assets/imgs/pic_10.png'), //图片
					content: 'xx集团有限责任公司成立于2007年，注册资金80万，是xxxx一家专业的网站策划公司。公司主要服务于中小企业，提供网站策划，网站设计制作建设，网络推广营销于一体的专业服务。公司以“专注网站，用心服务”为核心价值，希望通过我们的专业水平和不懈努力，重塑中小企业网络形象，为企业产品推广，文化建设传播提供服务指导。', //内容
					href: "", //链接
					isCompany: false,
				}],
				isFMR: true, // 弹窗展示、选中边框
				isLXR: false,
				isKF: false,
				form: { // 编辑数据
					posterSrc: require("../assets/imgs/pic_8.png"), // 封面
					comName: "中码服科技（北京）有限公司", // 公司名
					mobilePhone: "",
					comWebsite: "",
					comAddress: "",
					wbName: "",
					kfPhone: "",
					kfQQ: ""
				},
				checkList: ['QR码'],
				mbList: [],
				mbVal: '',
				clientHeight: 0, // 屏幕高度
				yardImgshow: false, // 预览框
				idcode: '',
				identification_ID: '',
				codeSrc: '',
				codeShow: false,
				mtList: ''	// 生成码图的列表
			}
		},
		mounted() {
			this.$store.commit('resistopen')
			//           this.$store.state.resistshow =true;
			//			console.log(this.$store.state.resistshow )
			this.$refs.mbBox.style.height = document.documentElement.clientHeight - 150 + 'px'
		},
		created() {
			console.log(this.$getCookie('idcode'))
			if (this.$getCookie('idcode')) { // 编辑操作
				console.log(this.$getCookie('idcode'))
				this.idcode = this.$getCookie('idcode')
				this.getIdcodeInfo()	// 获取详情
				this.codeShow = true	// 显示预览二维码
			}
			this.getMblist()	// 获取码标列表
		},
		destroyed() {
			//			console.log(this.$store.state.resistshow )

			this.$store.commit('resistDestroy')
			console.log('destroyed')
			this.$delCookie('idcode')
		},
		methods: {
			getIdcodeInfo() {	// 详情
				this.$http.get(this.$api + '/lightapp/getLightAppByIdcode', {
					params: {
						idcode: this.idcode
					}
				}).then(res => {
					if (res.body.result === 1) {
						console.log(res.body.entity.moduleList)
						var that = this
						this.form = {
							posterSrc: res.body.entity.moduleList.head.cover?res.body.entity.moduleList.head.cover:require("../assets/imgs/pic_8.png"),
							comName: res.body.entity.moduleList.head.name,
							mobilePhone: res.body.entity.moduleList.contact.phone,
							comWebsite: res.body.entity.moduleList.contact.href,
							comAddress: res.body.entity.moduleList.contact.address,
							wbName: res.body.entity.moduleList.contact.microblog,
							kfPhone: res.body.entity.moduleList.service.phone,
							kfQQ: res.body.entity.moduleList.service.qq
						}
						res.body.entity.moduleList.company.forEach((item,index)=>{
							if(!item.pic_name){
								item.pic_name = require('../assets/imgs/pic_10.png')
							} else if (item.pic_name == '0') {
								item.pic_name = ''
							}
							item.isCompany = false
						})
						this.comList = res.body.entity.moduleList.company
						
					} else {
						// this.tableData = [];
					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');
				
				})
			},
			IsURL(str_url) {
				var strRegex = '^(http|https|ftp)\://[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(:[a-zA-Z0-9]*)?/?([a-zA-Z0-9\-\._\?\,\'/\\\+&amp;%\$#\=~])*$'
			    var re = new RegExp(strRegex);
			    if (re.test(str_url.toLowerCase())) {
			        return (true);
			    } else {
			        return (false);
			    }
			},
			onWebsiteChange(e) {	// 公司官网
				// console.log(e.target.value)
				if(!this.IsURL(e.target.value)) {
					that.$message.warning('公司官网输入格式错误！')
					this.form.comWebsite = ''
				}
			},
			onLinkChange(e,idx) {	// 链接
				// console.log(e.target.value,idx)
				var that = this
				if(!this.IsURL(e.target.value)) {
					this.comList.forEach(function(item,index){
						if(idx == index) {
							that.$message.warning('链接输入格式错误！')
							item.href = ''
						}
					})
					// this.form.comWebsite = ''
				}
			},
			// 封面图
			handlePosterSuccess(res, file) {
				// this.form.posterSrc = URL.createObjectURL(file.raw);
				// console.log(res.entity.imageBig)
				this.form.posterSrc = res.entity.imageUrl + res.entity.imageBig
			},
			// handlePosterRemove(file) {
			// 	this.form.posterSrc = require("../assets/imgs/pic_8.png")
			// },
			getPosterChange(file, fileList) {
				if (fileList.length > 1) {
					fileList.splice(0, 1);
				}
			},
			handlePosterRemove() {
				this.form.posterSrc = require("../assets/imgs/pic_8.png")
			},
			showModel: function(info, idx) {
				switch (info) {
					case 'Rank':
						// var dom = this.$refs.Rank
						// console.log(dom.offsetTop)
						this.isFMR = true
						this.comList.forEach(function(item, index) {
							item.isCompany = false
						})
						this.isLXR = false,
							this.isSJR = false,
							this.isDZR = false,
							this.isGRR = false
						break;

					case 'Company':
						this.isFMR = false
						this.comList.forEach(function(item, index) {
							if (idx == index) {
								item.isCompany = true
							} else {
								item.isCompany = false
							}
						})
						this.$nextTick(() => {
							var dom = this.$refs.Company[idx]
							var dom2 = this.$refs.companyBlock[idx]
							console.log(dom,dom2)
							dom2.style.marginTop = dom.offsetTop - 120 + 'px'
						})
						this.isLXR = false,
							this.isKF = false
						break;

					case 'LX':
						this.isFMR = false
						this.comList.forEach(function(item, index) {
							item.isCompany = false
						})
						this.isLXR = true
						this.changeLXR()
						this.isKF = false
						break;

					case 'KF':
						this.isFMR = false
						this.comList.forEach(function(item, index) {
							item.isCompany = false
						})
						this.isLXR = false,
							this.isKF = true
						this.changeKFbox()
						break;

				}
			},
			delModel: function(info,idx) {
				switch (info) {
					case 'FM':
						this.isFMR = false
						break;
					case 'Company':
						this.$nextTick(() => {
							this.comList.forEach(function(item, index) {
								if(idx == index) {
									item.isCompany = false
								}
							})
						})
						console.log(this.comList)
						break;
					case 'LX':
						this.isLXR = false
						break;
					case 'KF':
						this.isKF = false
						break;
					default:
				}
			},
			// 改变联系人弹窗距上高度
			changeLXR: function() {
				var dom = this.$refs.LX
				this.$nextTick(() => {
					var dom2 = this.$refs.LXRbox
					if(dom2) {
						dom2.style.marginTop = dom.offsetTop - 120 + 'px'
					}
				})
			},
			// 改变客服弹窗距上高度
			changeKFbox: function() {
				var dom = this.$refs.KF
				// console.log(dom, dom.offsetTop)
				this.$nextTick(() => {
					var dom2 = this.$refs.KFbox
					if(dom2){
						console.log(dom2)
						dom2.style.marginTop = dom.offsetTop - 120 + 'px'
					}
				})
			},
			// 添加公司模板
			addModule: function() {
				var len = this.comList.length
				if (len > 5) {
					this.$message.warning('添加的模板已经达到上限!')
				} else {
					this.comList.push({
						title: 'xx集团有限责任公司',
						pic_name: require('../assets/imgs/pic_10.png'),
						content: 'xx集团有限责任公司成立于2007年，注册资金80万，是xxxx一家专业的网站策划公司。公司主要服务于中小企业，提供网站策划，网站设计制作建设，网络推广营销于一体的专业服务。公司以“专注网站，用心服务”为核心价值，希望通过我们的专业水平和不懈努力，重塑中小企业网络形象，为企业产品推广，文化建设传播提供服务指导。',
						isCompany: false,
						href: ''
					})
					this.changeLXR()
					this.changeKFbox()
				}
			},
			delModule: function(idx) {
				// console.log(idx)
				this.comList.splice(idx, 1)
				this.changeLXR()
			},
			// 公司图片
			handlePicSuccess(idx, res, file, fileList) {
				// console.log(res)
				var that = this
				that.comList.forEach(function(item, index) {
					if (index == idx) {
						// that.comList[index].pic_name = URL.createObjectURL(file.raw);
						that.comList[index].pic_name = res.entity.imageUrl + res.entity.imageBig;
					}
				})
				console.log('上传成功', that.comList)
			},
			handlePicRemove(idx) {
				var that = this
				that.comList.forEach(function(item, index) {
					if (index == idx) {
						that.comList[index].pic_name = ''
					}
				})
				console.log('删除成功', that.comList)
			},
			// getPicChange(file, fileList) {
			// 	if (fileList.length > 1) {
			// 		fileList.splice(0, 1);
			// 	}
			// },
			/**
			 * 通用对象克隆
			 *
			 * @param {*} obj
			 * @returns
			 */
			clone(obj) {
			    let temp = null;
			
			    if (obj instanceof Array) {
			        //temp = obj.concat();
			        temp = this.coppyArray(obj)
			    } else if (obj instanceof Function) {
			        //函数是共享的是无所谓的，js也没有什么办法可以在定义后再修改函数内容
			        temp = obj;
			    } else {
			        temp = new Object();
			        for (let item in obj) {
			            let val = obj[item];
			            if (val == null) {
			                temp[item] = null
			            }
			            else {
			                temp[item] = typeof val == 'object' ? clone(val) : val; //这里也没有判断是否为函数，因为对于函数，我们将它和一般值一样处理
			            }
			
			        }
			    }
			    //console.log('obj',temp)
			    return temp;
			},
			
			coppyArray(arr) {
			    return arr.map((e) => {
			        if (e instanceof Array) {
			            return coppyArray(e);
			        } else if (e instanceof Function) {
			            //函数是共享的是无所谓的，js也没有什么办法可以在定义后再修改函数内容
			            return e;
			        } else {
			            let temp = new Object();
			            for (let item in e) {
			                let val = e[item];
			                if (val == null) {
			                    temp[item] = null
			                }
			                else {
			                    temp[item] = typeof val == 'object' ? clone(val) : val; //这里也没有判断是否为函数，因为对于函数，我们将它和一般值一样处理
			                }
			
			            }
			            return temp;
			        }
			    })
			},
			// 获取码标列表
			getMblist() {
				this.$http.get(this.$api + '/lightapp/getIdentificationList', {
					params: {
						idcode: this.idcode,
					}
				}).then(res => {
					if (res.body.result === 1) {
						console.log(res.body.entity)
						this.mbList = []
						res.body.entity.forEach((item,index)=> {
							this.mbList.push({
								identification_ID: item.identification_ID,
								identification: item.identification
							})
							// this.checkList.push(item.)
						})
						this.mbVal = res.body.entity[0].identification_ID
						this.identification_ID = res.body.entity[0].identification_ID
						if(this.identification_ID) {
							this.showCode()	// 生成码图
						}
						
					} else {
						this.identification_ID = ''
					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');
				
				})
			},
			// 监听码标下拉切换
			onMbchange(val) {
				this.identification_ID = val
				this.showCode()
			},
			// 监听码制选择
			onMzchange() {
				console.log(this.checkList)
			},
			// 预览生成码图
			showCode() {
				// console.log(this.identification_ID)
				this.$http.get(this.$api + '/CodeImage/createCodeImage', {
					params: {
						idcode: this.idcode,
						identificationID: this.identification_ID
					}
				}).then(res => {
					if (res.body.result === 1) {
						// console.log(res.body.entity)
						this.mtList = res.body.entity.imgList
						this.codeSrc = res.body.entity.baseUrl + res.body.entity.imgList.QR码
						this.codeShow = true
						// console.log(this.codeSrc)
					} else {
						// this.tableData = [];
					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');
				
				})
			},
			downloadCode() {		// 打包下载码图
				console.log(this.checkList,'选中的码制')
				console.log(this.mtList,'码图列表')
				var idcode = this.$getCookie('idcode')
				if(!idcode) {
					this.$message.warning('请先预览或保存后再打包下载码图！')
					return false
				}
				var fileNames_arr = []
				if(this.checkList.length > 0 && this.mtList) {
					this.checkList.forEach((item,index)=> {
						for(let key in this.mtList) {
							if(item == key) {
								fileNames_arr.push(this.mtList[item])
							}
						}
					})
				} else {
					this.$message.warning('请先选择码制！')
					return false
				}
				var fileNames = fileNames_arr.join(',')
				console.log(fileNames)
				console.log(this.$api+ "/CommonMethod/ZipDownloadsBatch/?fileNames=" + fileNames + "&filePath=CreateCode")
				location.href = this.$api+ "/CommonMethod/ZipDownloadsBatch/?fileNames=" + fileNames + "&filePath=CreateCode";
			},
			saveCompany: function(status) {
				var uploadFile = true
				if(this.form.posterSrc.indexOf('pic_8') > -1) {
					uploadFile = false
				}
				if (!this.form.comName) {
					this.$message.warning('请输入公司名称')
					return false
				}
				var submitCompany = []
				// submitCompany = JSON.parse(JSON.stringify(this.comList))
				submitCompany = this.clone(this.comList)
				submitCompany.forEach(function(item,index){
					console.log(item.pic_name)
					if(item.pic_name.indexOf('/pic_10')>-1) {
						submitCompany[index].pic_name = ''
					} else if(item.pic_name == '') {
						submitCompany[index].pic_name = '0'
					}
				})
				var param = {
					idcode: this.idcode ? this.idcode : '',
					template_id: 1, // 公司模板
					moduleList: {
						head: {
							cover: uploadFile?this.form.posterSrc:'', //封面图
							name: this.form.comName //公司名称
						},
						company: submitCompany,
						contact: { //联系方式
							phone: this.form.mobilePhone, //联系电话
							href: this.form.comWebsite, //公司官网
							address: this.form.comAddress, //公司地址
							microblog: this.form.wbName //微博名称
						},
						service: { //客服信息
							phone: this.form.kfPhone, //客服电话
							qq: this.form.kfQQ //客服QQ
						}
					}
				}
				// console.log(param,JSON.stringify(param))
				this.$http.post(this.$api + '/lightapp/saveCompanyCode', JSON.stringify(param)).then(res => {
					//						console.log(res.body);
					if (res.body.result === 1) {
						// 点预览时，调接口保存数据，成功后弹出预览窗口；
						// 点保存是，调接口保存数据，成功后询问“是否继续编辑”
						this.idcode = res.body.entity.idcode	// 继续编辑或者预览后在编辑改成编辑状态后保存要发送idcode参数
						this.$setCookie('idcode',this.idcode)
						if (status == 0) { // 预览
							this.yardImgshow = true
							this.showCode()
						} else if (status == 1) { // 保存
							// this.$message({
							// 	message: '保存成功，',
							// 	type: 'success'
							// });
							// this.$router.go(-1)
							this.$confirm('保存成功,是否继续编辑?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								console.log('继续编辑')
							}).catch(() => {
								console.log('返回列表')
								this.$router.go(-1)
							});
						}

					} else {
						this.$message.error(res.body.message);
					}
				})
			},
			gotoUrl: function(url) {
				if (url) {
					// console.log(url)
					window.open(url, "_blank");
					// window.location.href = url
				}
			}
		}
	}
</script>
<style>
	.cover-img1 h3 {
		text-align: center;
		padding: 10px;
		font-size: 16px;
		color: #666666;
		font-weight: normal;
	}

	.contect-list li label {
		width: 80px !important;
	}

	.previewBox2 .el-dialog {
		background: transparent !important;
		box-shadow: none !important;
	}

	.previewBox2 .el-dialog__body {
		/* width: 100%;
		box-sizing: border-box !important; */
		padding: 0 !important;
		font-size: 16px !important;
	}

	.previewBox2 .phoneBox {
		margin-top: -3px;
		background-color: #fff;
		height: 500px;
		/* padding-top: 4%; */
		overflow: -moz-scrollbars-none;
		scrollbar-width: none;
		-ms-scroll-chaining: chained;
		-ms-content-zooming: zoom;
		-ms-scroll-rails: none;
		-ms-content-zoom-limit-min: 100%;
		-ms-content-zoom-limit-max: 500%;
		-ms-scroll-snap-type: proximity;
		-ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
		-ms-overflow-style: none;
		overflow: auto;
	}

	.phoneBox::-webkit-scrollbar {
		display: none;
		width: 0;
	}

	.previewBox2 .el-dialog__headerbtn {
		right: -50px !important;
		background-color: #fff !important;
		border-radius: 50%;
		padding: 3px 4px !important;
	}

	.add-div {
		text-align: center;
		padding: 20px 0;
	}

	.popou-choose {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}

	.popou-choose .el-checkbox {
		margin-right: 0;
	}

	#allmap {
		height: 600px;
		width: 600px;
		margin: 0 auto;
	}

	.br_green {
		border-right: 2px solid #4caf50;
	}

	.contect-list li label {
		display: inline-block;
		width: 70px;
	}

	#content {
		/*width: 82.7%;*/
		width: 100%;
		min-width: 1060px;
		padding: 20px;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
	}

	#model1 .left {
		width: 52.6%;
		float: left;
		background: #fff;
		min-width: 530px;
		border: 1px solid #e8e8e8;
		border-top: none;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
	}

	#model1 .left.right {
		width: 46.6%;
		min-width: 475px;
		float: right;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
	}

	#model1 .left .major {
		width: 201px;
		height: 202px;
		/*background: url("../img/codebg.png") no-repeat;*/
		background-size: 100%;
		position: relative;
		float: left;
		transition: all .5s;
	}

	#model1 .left .major img {
		width: 100px;
		height: 100px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		transition: all 1s;
	}

	#model1 .l_top {
		padding: 29px 40px;
		min-height: 216px;
		transition: all .5s;
	}

	#model1 .l_top li {
		display: inline-block;
		height: 85px;
		border: 1px solid #e3e3e3;
		float: left;
		width: 131px;
		margin-bottom: 13px;
		transition: all .5s;
		position: relative;
	}

	#model1 .l_top .current {
		border: 1px solid #f09d1a;
	}

	#model1 .l_top .right-icon {
		display: block;
		width: 24px;
		height: 24px;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	#model1 .l_top li:nth-child(2n-1) {
		margin-right: 30px;
	}

	#model1 .l_top li img {
		margin: 7px 10px;
	}

	#model1 .l_top li div {
		height: 85px;
		line-height: 85px;
		width: 37px;
		background: #f2f2f2;
		float: right;
		text-align: center;
	}

	#model1 .l_top li span {
		display: inline-block;
		font-size: 14px;
		width: 20px;
		color: #767676;
		vertical-align: middle;
		line-height: 20px;
	}

	#model1 .l_top ul {
		width: 300px;
		float: left;
		margin-left: 30px;
		transition: all 1s;
	}

	#model1 .l_bot {
		width: 100%;
		height: 60px;
		line-height: 60px;
		font-size: 16px;
		border-top: 1px solid #e8e8e8;
	}

	#model1 .l_bot a {
		display: inline-block;
		width: 50%;
		text-align: center;
		color: #298bef;
		float: left;
		background: #fafafa;
	}

	#model1 .l_bot a:hover {
		font-weight: 700;
	}

	#model1 .l_bot a:nth-child(1) {
		border-right: 1px solid #e8e8e8;
		box-sizing: border-box;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;

	}

	#model1 .right {
		text-align: center;
	}

	#model1 .right .floor {
		margin: 0 auto 24px;
		height: 68px;
		width: 68px;
		border-radius: 50%;
		background: #f7f7f7;
		border: 1px solid #e5e5e5;
		text-align: center;
		line-height: 66px;
	}

	#model1 .right .floor img {
		width: 41px;
		height: 37px;
		display: inline-block;
		vertical-align: middle;
	}

	#model1 .right .l_top p {
		margin-bottom: 10px;
	}

	.font12 {
		font-size: 12px;
		color: #999;
		margin-bottom: 9px !important;
	}

	#model1 .right .l_top .icon span {
		color: #e62323;
		line-height: 14px;
		vertical-align: middle;
	}

	#model1 .right .l_top .icon i {
		display: inline-block;
		width: 14px;
		height: 14px;
		/* background: url("../img/mark.png") no-repeat; */
		background-size: 100%;
		margin-right: 5px;
		vertical-align: middle;
	}

	#model2 {
		margin: 14px 0;
	}

	#model2 .left {
		width: 36%;
		min-width: 368px;
		float: left;
		background: #fff;
		border: 1px solid #e8e8e8;
		border-top: none;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
	}

	#model2 .left.right {
		width: 63%;
		min-width: 640px;
		float: right;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
	}

	#model2 .l_top2 {
		height: 52px;
		line-height: 52px;
		font-size: 16px;
		border-bottom: 1px solid #e1e1e1;
	}

	#model2 .l_top2 span {
		border-left: 4px solid #58a4f3;
		padding-left: 10px;
		margin-left: 12px;

	}

	#model2 .l_bot2 p span {
		margin-left: 10px;
	}

	#model2 .l_bot2 {
		text-align: center;
		line-height: 34px;
		font-size: 16px;
		padding-bottom: 32px;
	}

	#model2 .l_bot2 .mainnum {
		font-size: 18px;
		line-height: 83px;
		margin-top: 15px;
	}

	#model2 .l_bot2 .mainnum span {
		font-size: 36px;
		margin-left: 0;
		margin-right: 10px;
	}

	#model2 .r_bot2 {
		padding: 35px 40px;
	}

	#model2 .r_bot2 li {
		height: 170px;
		padding: 22px 9px 11px;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		-o-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
		width: 31.5%;
		float: left;
		border: 1px solid #e1e1e1;
		font-size: 14px;
		position: relative;
		text-align: center;
	}

	#model2 .r_bot2 li p {
		color: #666;
		text-align: left;
		line-height: 24px;
		margin-top: 24px;
	}

	#model2 .r_bot2 li a {
		color: #666666;
		position: absolute;
		bottom: 10px;
		right: 10px;
	}

	#model2 .r_bot2 li a:hover {
		color: #298BEF;
	}

	#model2 .r_bot2 li:nth-child(2) {
		margin: 0 2%;
	}

	#model3 {
		width: 100%;
		min-width: 1000px;
		background: #fff;
		border: 1px solid #e8e8e8;
		border-top: none;
	}

	#model3 .top {
		height: 52px;
		line-height: 52px;
		font-size: 16px;
		border-bottom: 1px solid #e1e1e1;
	}

	#model3 .top span {
		border-left: 4px solid #58a4f3;
		padding-left: 10px;
		margin-left: 12px;
	}

	#model3 .main {
		padding: 26px 10px;
		color: #666;
	}

	#model3 .main input {
		height: 19px;
	}

	#model3 .main input.name {
		width: 244px;
	}

	#model3 .main input.time {
		width: 100px;
	}

	#model3 button {
		background: none;
		width: 98px;
		height: 35px;
		line-height: 35px;
		text-align: center;
		color: #298bef;
		border: 1px solid #298bef;
		float: right;
		/* margin-right: 20px;*/
	}

	#model3 button:hover {
		background: #298BEF;
		color: #FFFFFF;

	}

	#model3 select {
		width: 172px;
		height: 35px;
	}

	.mar10 {
		margin-right: 10px;
	}

	.mal10 {
		margin-left: 200px;
		margin-top: -48px;
	}

	.mal101 {
		margin-left: 10px;
		margin-top: -48px;
	}

	.mar25 {
		margin-left: 25px;
		margin-right: 10px;
	}

	.mar6 {
		margin: 0 6px;
	}

	.mat20 {
		margin-top: 20px;
	}

	.condition input {
		border: 1px solid #E1E1E1;
	}

	.condition select {
		border: 1px solid #E1E1E1;
	}

	.tab-jl {
		border: 1px solid #E1E1E1;
	}

	.tab-jl th {
		text-align: center;
		line-height: 36px;
		background-color: #fcfcfc;
		border-bottom: 1px solid #E1E1E1;
	}

	.tab-jl td {
		line-height: 36px;
		text-align: center;
		font-size: 12.5px;
		border-bottom: 1px solid #E1E1E1;
		box-sizing: border-box;
	}

	.tab-cz a {
		display: inline-block;
		color: #298BEF;
		margin: 0 10px;
	}

	.tab-jl tr:nth-child(odd) {
		background: #fcfcfc;
	}

	.btn-more {
		text-align: center;
		margin-top: 10px;
	}

	.btn-more a {
		display: block;
		color: #f09d1a;
	}

	.fl {
		float: left;
	}

	.fr {
		float: right;
	}

	.clearfix:before,
	.clearfix:after {
		content: '';
		display: table;
	}

	.clearfix:after {
		clear: both;
	}

	.clearboth:after {
		display: block;
		clear: both;
		content: "";
		overflow: hidden;
		height: 0;
	}

	.person-cover {
		width: 100%;
		height: 230px;
		/* background: url(../assets/imgs/pic_9.png) no-repeat center; */
		background-size: cover;
		/* position: relative; */
	}

	.person-cover2 {
		height: 260px;
	}

	.person-head {
		width: 90px;
		height: 90px;
		border-radius: 90px;
		position: absolute;
		top: 75px;
		left: 20px;
		overflow: hidden;
	}

	.person-head img {
		width: 90px;
		height: 90px;
	}

	.person-head2 {
		position: absolute;
		left: 50% !important;
		margin-left: -45px;
		top: 20px !important;
	}

	.person-head3 {
		position: absolute;
		left: inherit;
		right: 20px !important;
		top: 75px;
	}

	.person-text {
		position: absolute;
		top: 84px;
		left: 130px;
		text-align: left;
	}

	.person-text2 {
		text-align: center;
		position: absolute;
		top: 120px;
		left: 50%;
		margin-left: -110px;
	}

	.person-text2 p {
		width: 220px !important;
	}

	.person-text3 {
		position: absolute;
		left: inherit;
		top: 84px;
		right: 130px !important;
		text-align: right;
	}

	.person-text h3 {
		color: #FFFFFF;
		font-size: 18px;
		font-weight: normal;
	}

	.person-text p {
		color: #FFFFFF;
		margin-top: 6px;
		width: 190px;
	}

	.contact-list {
		margin: 0;
		padding: 0;
	}

	.contact-list li {
		box-sizing: border-box;
		padding: 14px 20px;
		border-top: 1px solid #E1E1E1;
		text-align: left;
	}

	.contact-box {
		position: relative;
	}

	.re-position {
		position: relative;
		top: -10px;
		left: 40px;
	}

	.com-list2 .re-position,
	.com-list .re-position {
		text-align: left;
		padding-left: 40px;
	}

	.com-list2 li {
		margin-top: 5px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.com-list2 label {
		float: left;
	}

	.com-list2 input {
		margin-top: -5px;
		width: 250px !important;
	}

	.com-list3 input {
		width: 200px !important;
	}

	.com-list3 label {
		width: 60px !important;
	}

	.com-list3 .adress-icon {
		display: inline-block;
		color: #298BEF;
	}

	.com-list3 .adress-icon i {
		display: inline-block;
		width: 12px;
		height: 16px;
		background: url(../assets/imgs/address-1.png) no-repeat;
		background-size: 100%;
		position: relative;
		top: 3px;
		margin-left: 2px;
		margin-right: 2px;
	}

	.com-list4 label {
		display: inline-block;
		float: left;
		width: 90px !important;
		text-align: right;
	}

	.com-list4 textarea {
		display: inline-block;
		float: left;
		width: 260px;
		height: 100px;
		border: 1px solid #E1E1E1;
	}

	.add-icon {
		display: inline-block;
		width: 22px;
		height: 22px;
		background: url(../assets/imgs/add-2.png) no-repeat;
		background-size: 100%;
		position: relative;
		top: 5px;
		left: 10px;
	}

	.sc {
		display: inline-block;
		width: 22px;
		height: 22px;
		background: url(../assets/imgs/minus_03.png) no-repeat;
		background-size: 100%;
		position: relative;
		top: 5px;
		left: 12px;
	}

	.com-list2 li label {
		display: inline-block;
		width: 80px;
		text-align: right;
		color: #666666;
	}

	.show-position img {
		display: inline-block;
		margin-right: 3px;
	}

	.mb-phone {
		width: 360px;
	}

	.phone-top {
		height: 43px;
	}

	.phone-topCompany {
		height: 43px;
	}

	.cover-img img {
		width: 358px;
	}

	.border-bottom {
		border-bottom: 1px solid #F0F0F0;
	}

	.white-bj {
		background-color: #FFFFFF;
	}

	.cover-img h3 {
		text-align: center;
		padding: 10px;
		font-size: 16px;
		color: #666666;
	}

	.company-js h3 {
		font-size: 14px;
		font-weight: 700;
		color: #666666;
	}

	.company-js h3 a {
		color: #666666;
	}

	.company-js h3 i {
		display: inline-block;
		width: 16px;
		height: 16px;
		background: url(../assets/imgs/icon-2.png) no-repeat center;
		background-size: 100%;
		margin-right: 6px;
	}

	.padding16 {
		padding: 16px;
	}

	.com-img img {
		width: 100%;
	}

	.mat16 {
		margin-top: 16px;
	}

	.mat06 {
		margin-top: 6px;
	}

	.com-text p {
		/*text-indent: 24px;*/
		color: #666666;
		line-height: 1.6;
	}

	.contect-list li {
		color: #666666;
		padding-top: 10px;
		text-align: left;
	}

	.contect-list li input {
		width: 280px;
		height: 32px;
		border: 1px solid #E1E1E1;
	}

	.contect-list .adress {
		display: inline-block;
		width: 12px;
		height: 16px;
		/* background: url(../images/address-2.png) no-repeat; */
		position: relative;
		top: 2px;
		left: 4px;
	}

	.popou-commen {
		width: 400px;
		background-color: #FFFFFF;
		border: 1px solid #E1E1E1;
		position: relative;
	}

	.popou-commen .trangle1 {
		display: block;
		width: 16px;
		height: 16px;
		background: url(../assets/imgs/trangle_03.png) no-repeat left;
		background-size: 100%;
		position: absolute;
		top: 20px;
		left: -16px;
	}

	.up-img {
		width: 90px;
		height: 60px;
		border: 1px solid #E1E1E1;
		overflow: hidden;
		text-align: center;
		display: table;
		vertical-align: middle;
		/*margin-top: 0px;*/
	}

	.up-img>div {
		width: 90px;
		height: 60px;
		display: table-cell;
		text-align: center;
		vertical-align: middle;
	}

	.up-img img {
		max-width: 90px;
		max-height: 67px;
	}

	.previewBox {
		position: relative;
		width: 90px;
		margin-left: 30px;
	}

	.previewBox .cloose11 {
		display: block;
		width: 16px;
		height: 16px;
		/* background: url(../images/off-btn2.png) no-repeat; */
		position: absolute;
		top: -5px;
		right: -8px;
	}

	.previewBox .cloose111 {
		display: block;
		width: 16px;
		height: 16px;
		background: url(../assets/imgs/off-btn2.png) no-repeat;
		position: absolute;
		top: -8px;
		right: -8px;
	}

	.mal20 {
		margin-left: 20px;
	}

	.up-img-box input {
		display: block;
		opacity: 0;
	}

	/*.up-img-box input:hover{*/
	/*background-color: #298BEF;*/
	/*color: #FFFFFF;*/
	/*}*/
	.tishi-gray {
		font-size: 12px;
		color: #999999;
		margin-top: 10px;
	}

	.popou-commen .cloose2 {
		display: block;
		width: 16px;
		height: 16px;
		background: url(../assets/imgs/cloose_03.jpg) no-repeat center;
		/*background-size: cover;*/
		position: absolute;
		right: 10px;
		top: 10px;
		cursor: pointer;
	}

	.hide {
		display: none;
	}

	.mb-popou {
		margin-left: 20px;
	}

	.padding20 {
		padding: 20px 0;
	}

	#content {
		font-size: 14px;
		height: 100%;
	}

	.com-list {
		margin-top: 20px;
	}

	.com-list li {
		margin-top: 5px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.com-list input {
		width: 300px;
		height: 32px;
		border: 1px solid #E1E1E1;
		padding-left: 6px;
	}

	/* .pic-box button{
		float: left;
		display: block;
		width: 70px;
		height: 24px;
		background-color: #FFFFFF;
		color: #298BEF;
		border: 1px solid #298BEF;
		border-radius: 2px;
		margin-left: 6px;
	}
	.pic-box button:hover{
		background-color: #298BEF;
		color: #FFFFFF;
	} */

	.com-list label {
		float: left;
	}

	.com-list textarea {
		width: 300px;
		height: 80px;
		border: 1px solid #E1E1E1;
		padding-left: 6px;
		display: none;
	}

	.upload-avatar {
		display: inline-flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.el-upload-list {
		margin-left: 10px !important;
		max-height: 122px;
		overflow: hidden;
	}

	.big-box2,
	.big-box1,
	.big-box3 {
		position: relative;
		width: 100%;
		/*height: 100%;*/
	}

	.blue-box2,
	.blue-box1,
	.blue-box3,
	.blue-box4,
	.zzc {
		background: rgba(41, 139, 239, .76);
		position: absolute;
		top: 0;
		z-index: 1;
		width: 100%;
		height: 100%;

	}

	.blue-box1 h3,
	.blue-box2 h3,
	.blue-box3 h3,
	.blue-box4 h3 {
		color: #FFFFFF;
		font-size: 14px;
		text-align: center;
		position: absolute;
		top: 40%;
		left: 40%;
	}

	.blue-box1 {
		opacity: 0;
	}

	.big-box1:hover .blue-box1 {
		opacity: 1;
	}

	.blue-box2 {
		opacity: 0;
	}

	.big-box2:hover .blue-box2 {
		opacity: 1;
	}

	.blue-box3 {
		opacity: 0;
	}

	.big-box3:hover .blue-box3 {
		opacity: 1;
	}

	.blue-box4 {
		opacity: 0;
	}

	.big-box4:hover .blue-box4 {
		opacity: 1;
	}

	.download-box {
		background-color: #FFFFFF;
		width: 280px;
		border: 1px solid #E1E1E1;
	}

	.popou-ma1 {
		position: relative;
	}

	.popou-ma1 .cloose {
		position: absolute;
		top: -6px;
		right: 6px;
		cursor: pointer;
	}

	.re-margin {
		margin-top: 20px;
		margin-bottom: 10px;
	}

	.popou-ma1 .line {
		width: 100%;
		height: 1px;
		background-color: #dddddd;

	}

	.popou-ma1 h3 {
		text-align: center;
		margin: 10px;
	}

	.popou-ma1 p {
		text-align: center;
		color: #333333;
		margin-top: 20px;
	}

	.download-btns {
		text-align: center;
	}

	.download-btns input {
		width: 70px;
		height: 32px;
		background-color: #298BEF;
		color: #FFFFFF;
		border-radius: 2px;
		margin: 10px;

	}

	.download-btns input:hover {
		background-color: #6faff1;
	}

	.btn-long input:hover {
		background-color: #f4b148;
	}

	.ma-box {
		width: 220px;
		height: 220px;
		/*background: url(../img/codebg.png) no-repeat center;*/
		background-size: cover;
		-webkit-background-size: cover;
		text-align: center;
		margin: 30px auto;
	}

	.ma-box img {
		width: 220px;
		margin-top: 0px;
	}

	#mbBox::-webkit-scrollbar {
		width: 0 !important
	}

	#mbBox {
		-ms-overflow-style: none;
		overflow: -moz-scrollbars-none;
		scrollbar-width: none;
	}

	.delet-odd {
		position: absolute;
		right: 10px;
		top: 6px;
		z-index: 2;
	}

	.delet-odd a {
		display: block;
		width: 30px;
		height: 50px;
		background: url(../assets/imgs/delet-icon_05.png) no-repeat;
	}

	.delet-odd a:hover {
		background: url(../assets/imgs/delat1_03.png) no-repeat;
	}

	.contect-list li {
		margin-top: 10px;
	}
</style>

<style lang="scss">
	.result-box {
		.el-table {
			.cell {
				text-align: center;
			}
		}
	}
</style>
